// Arabic — RTL
export const ar = {
  'nav.skipContent': 'الانتقال إلى محتوى الصفحة',
  'nav.solutions': 'حلول البث المباشر',
  'nav.streamTemplates': 'قوالب البث',
  "nav.prepare": "التحضير",
  "nav.events": "الفعاليات والبث المباشر",
  "nav.featurePresets": "إعدادات الميزات",
  "nav.interact": "التفاعل",
  "nav.boards": "اللوحات التفاعلية",
  "nav.measure": "التقارير والتجارة",
  "nav.menu": "فتح القائمة",
  "nav.closeMenu": "إغلاق القائمة",

  'app.name':           'Kardolive',
  'app.tagline':        'بوابة العميل',
  'app.signOut':        'تسجيل الخروج',

  'login.email':        'البريد الإلكتروني',
  'login.password':     'كلمة المرور',
  'login.signIn':       'تسجيل الدخول',
  'login.signingIn':    'جارٍ تسجيل الدخول…',
  'login.failed':       'فشل تسجيل الدخول',
  'login.newAccount':   'جديد على Kardolive؟',
  'login.createAccount':'إنشاء حساب مجاني ←',

  'nav.workspace':      'مساحة العمل',
  'nav.templates':      'القوالب',
  'nav.live':           'البث المباشر',
  'nav.rooms':          'الغرف والدردشة',
  'nav.content':        'المحتوى',
  'nav.developer':      'المطوّر',
  'nav.account':        'الحساب',

  'nav.overview':       'نظرة عامة',
  'nav.projects':       'المشاريع',
  'nav.chat':           'وحدة الدردشة',
  'nav.sessions':       'الجلسات',
  'nav.streams':        'البث المباشر',
  'nav.studio':         'الاستوديو',
  'nav.recordings':     'التسجيلات',
  'nav.apiKeys':        'مفاتيح API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'اختبار Webhook',
  'nav.networkTest':    'اختبار الشبكة',
  'nav.embed':          'الأدوات المضمَّنة',
  'nav.sdk':            'SDKs والمستندات',
  'nav.docs':           'مستندات المطوّر',
  'nav.analytics':      'التحليلات',
  'nav.settings':       'الإعدادات',

  'overview.welcome':       'مرحباً بعودتك، {name}',
  'overview.plan':          '{tenant} · باقة {plan}',
  'overview.newStream':     'بث جديد',
  'overview.kpi.live':           'مباشر الآن',
  'overview.kpi.live.broadcasting': 'بث جارٍ',
  'overview.kpi.live.nothing':    'لا يوجد بث مباشر',
  'overview.kpi.total':           'إجمالي البث',
  'overview.kpi.total.sub':       'كل الفترات',
  'overview.kpi.sessions':        'الجلسات · 30 يوماً',
  'overview.kpi.sessions.sub':    'أحداث النشر',
  'overview.kpi.recordings':      'التسجيلات',
  'overview.kpi.recordings.sub':  'جاهزة للتشغيل',
  'overview.recentStreams':       'البث الأخير',
  'overview.recentSessions':      'الجلسات الأخيرة',
  'overview.viewAll':             'عرض الكل ←',
  'overview.empty.title':         'لا يوجد بث بعد',
  'overview.empty.body':          'أنشئ أول بث لك لتبدأ البث المباشر.',
  'overview.empty.action':        'إنشاء بث',
  'overview.noSessions':          'لا توجد جلسات بعد',

  'status.live':        'مباشر',
  'status.idle':        'خامل',
  'status.ended':       'انتهى',
  'status.archived':    'مؤرشف',

  'common.save':        'حفظ',
  'common.cancel':      'إلغاء',
  'common.delete':      'حذف',
  'common.edit':        'تعديل',
  'common.create':      'إنشاء',
  'common.confirm':     'تأكيد',
  'common.loading':     'جارٍ التحميل…',
  'common.error':       'خطأ',
  'common.retry':       'إعادة المحاولة',
  "dashboard.stale": "تعذّر التحديث. تُعرض آخر معلومات تم تحميلها.",
  "dashboard.loadFailed": "تعذّر تحميل هذا القسم. يرجى المحاولة مجددًا.",
  "dashboard.overviewIntro": "البث المباشر وخطواتك التالية في مكان واحد.",
  "dashboard.liveNow": "مباشر الآن",
  "dashboard.upNext": "القادم",
  "dashboard.continue": "متابعة العمل",
  "dashboard.openBroadcast": "فتح أدوات البث",
  "dashboard.openStream": "فتح البث",
  "dashboard.scheduled": "مجدول",
  "dashboard.schedule": "جدولة بث",
  "dashboard.manualStart": "الأوقات المجدولة توضح موعد البث. اضغط بدء البث لبدء الإرسال.",
  "dashboard.noSchedule": "لا توجد عمليات بث قادمة. أضف موعدًا عند إنشاء البث التالي.",
  "dashboard.noRecent": "ستظهر عمليات البث الأخرى هنا.",
  "dashboard.summary": "ملخص مساحة العمل",
  "dashboard.analytics": "عرض التحليلات",
  "dashboard.minutes": "دقائق البث",
  "dashboard.last30": "آخر ٣٠ يومًا",
  "dashboard.quickStart": "هل تبدأ الآن؟ اطّلع على الخطوات التالية",
  "dashboard.prepareCamera": "تحقق من الكاميرا واستعد للبث",
  "dashboard.recordingHint": "إذا كان التسجيل مفعّلًا، تحقق من حالته بعد البث في",
  "dashboard.dismiss": "إخفاء هذا الدليل",
  "dashboard.recordingsIntro": "تسجيلات البث الخاصة بك. شاهد المقاطع الجاهزة وتحقق من حالة التسجيل هنا.",
  "dashboard.account": "الحساب",
  "dashboard.language": "اللغة",
  "dashboard.appearance": "المظهر",
  "dashboard.close": "إغلاق",
  "nav.allStreams": "كل البثوث",
  "nav.destinations": "وجهات البث",
  "nav.ecommerce": "التجارة الإلكترونية",
  "nav.products": "المنتجات",
  "nav.services": "الخدمات",
  "nav.collections": "المجموعات",
  "nav.orders": "الطلبات",
  "nav.commerceSettings": "إعدادات التجارة",
  "nav.engagement": "التفاعل",

  // Dashboard navigation and account controls.
  "nav.scenarios": "سيناريوهات الاستخدام",
  "nav.premieres": "العروض الأولى",
  "nav.clips": "المقاطع",
  "theme.light": "التبديل إلى المظهر الفاتح",
  "theme.dark": "التبديل إلى المظهر الداكن",
  "role.owner": "المالك",
  "role.admin": "المسؤول",
  "role.member": "العضو",
  "role.viewer": "المشاهد",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "النشطة",
  "streams.archived": "المؤرشفة",
  "streams.monitor": "مراقبة مصادر البث",
  "streams.create": "إنشاء بث مباشر",
  "streams.list": "قائمة",
  "streams.grid": "شبكة",
  "streams.view": "طريقة عرض البثوث",
  "streams.searchLabel": "البحث عن أحداث",
  "streams.searchHint": "ابحث باسم الحدث",
  "streams.solutionFilter": "تصفية الأحداث حسب نوع البث",
  "streams.statusFilter": "تصفية الأحداث حسب الحالة",
  "streams.dateFilter": "تصفية الأحداث حسب تاريخ الإنشاء",
  "streams.allSolutions": "جميع أنواع البث",
  "streams.custom": "إعداد موجود أو مخصص",
  "streams.allStatuses": "جميع الحالات",
  "streams.anyTime": "جميع تواريخ الإنشاء",
  "streams.last7": "أُنشئت خلال آخر ٧ أيام",
  "streams.last30": "أُنشئت خلال آخر ٣٠ يومًا",
  "streams.count": "عرض {shown} من {total} حدث",
  "streams.noMatch": "لا توجد أحداث تطابق عوامل التصفية.",
  "streams.clearFilters": "مسح عوامل التصفية",
  "streams.refreshFailed": "تعذّر تحديث قائمة البثوث",
  "streams.loadFailed": "تعذّر تحميل البثوث",
  "streams.stale": "تُعرض آخر قائمة محمّلة. ربما تغيّرت حالة البثوث.",
  "streams.connectionHint": "تحقق من اتصالك وأعد تحميل القائمة.",
  "streams.retrying": "جارٍ إعادة المحاولة…",
  "streams.retry": "حاول مجددًا",
  "streams.restoreFailed": "تعذّرت استعادة البث",
  "streams.restoreHint": "تحقق من اتصالك وحدّث القائمة لمعرفة الحالة الحالية قبل إعادة المحاولة.",
  "streams.unused": "بثوث غير مستخدمة: {count}",
  "streams.unusedHint": "لم تُجرَ بثوث أو تُحفظ إعادات. يمكنك أرشفتها لترتيب القائمة دون حذفها.",
  "streams.reviewArchive": "مراجعة وأرشفة",
  "streams.loading": "جارٍ تحميل البثوث…",
  "streams.archiveEmpty": "لا توجد بثوث مؤرشفة. تبقى البثوث المؤرشفة وإعاداتها هنا حتى تستعيدها.",
  "streams.restore": "استعادة",
  "streams.firstTitle": "أنشئ أول بث لك",
  "streams.firstBody": "اختر إعدادًا للبيع أو التعليم أو تقديم خدمة، أو ابدأ ببث فارغ. يمكنك البث من المتصفح أو الهاتف أو OBS.",
  "streams.blank": "بث فارغ",
  "streams.broadcasts": "مرات البث: {count}",
  "streams.replays": "الإعادات: {count}",
  "streams.sessions": "الجلسات: {count}",
  "streams.recordings": "التسجيلات: {count}",
  "streams.mode.BROADCAST": "بث",
  "streams.mode.LOW_LATENCY": "زمن انتقال منخفض",
  "streams.mode.REALTIME": "في الوقت الفعلي",
  "streams.key": "المفتاح",
  "streams.archiveTitle": "أرشفة البثوث غير المستخدمة",
  "streams.archiveHint": "لم تُستخدم هذه الأحداث للبث. يمكنك استعادتها في أي وقت من علامة التبويب «المؤرشفة».",
  "streams.archiveFailed": "تعذّرت أرشفة {count} من البثوث؛ ربما بدأت بالبث المباشر. تمت أرشفة البقية.",
  "streams.archiving": "جارٍ الأرشفة…",
  "streams.archiveCount": "أرشفة {count}",
  "streamType.webinar": "ندوات الأعمال وإطلاق المنتجات",
  "streamType.classroom": "الفصول والدروس الخصوصية",
  "streamType.training": "تدريب المؤسسات",
  "streamType.conference": "المؤتمرات والمعارض",
  "streamType.shopping": "التسوق المباشر",
  "streamType.auction": "المزادات المباشرة",
  "streamType.consultation": "الاستشارات الخاصة",
  "streamType.creator": "بث صناع المحتوى والمجتمعات",
  "streamType.audio": "الغرف الصوتية والبودكاست",
  "streamType.sports": "الرياضة والرياضات الإلكترونية",
  "streamType.performance": "الحفلات والعروض",
  "streamType.community": "الفعاليات الدينية وجمع التبرعات",
  "streamType.tour": "الجولات والعروض التوضيحية",
  "streamType.fitness": "اللياقة وورش العمل",
  "streamType.public-meeting": "الأخبار والاجتماعات العامة",
  "streamType.continuous": "القنوات والكاميرات المستمرة",
  "streams.close": "إغلاق",
};
